var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Dialog } from "@sequentech/ui-essentials";
import { isString } from "@sequentech/ui-core";
import { useMemo, useState } from "react";
import { Button, Datagrid, List, SaveButton, SimpleForm, TextField, TextInput, WrapperField, useEditController, useNotify, useUpdate, } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import Add from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
// import { Sequent_Backend_Election_Event_Extended } from "./EditElectionEventDataForm"
import { ActionsColumn } from "@/components/ActionButons";
import { Box, Drawer, FormControl, InputLabel, MenuItem, Select, Typography, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PageHeaderStyles } from "@/components/styles/PageHeaderStyles";
import { useTenantStore } from "@/providers/TenantContextProvider";
var SettingsLocalization = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    // const record = useRecordContext<Sequent_Backend_Tenant>()
    var tenantId = useTenantStore()[0];
    var _k = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _k.record, save = _k.save, recordLoading = _k.isLoading;
    var defaultLanguageConf = {
        enabled_language_codes: ["en"],
        default_language_code: "en",
    };
    var _l = useState((_b = (_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.language_conf) !== null && _b !== void 0 ? _b : defaultLanguageConf), languageConf = _l[0], setLanguageConf = _l[1];
    var _m = useUpdate(), update = _m[0], isLoading = _m[1].isLoading;
    console.log({ record: record });
    var t = useTranslation().t;
    var notify = useNotify();
    var _o = useState((_c = languageConf === null || languageConf === void 0 ? void 0 : languageConf.default_language_code) !== null && _c !== void 0 ? _c : "en"), selectedLanguage = _o[0], setSelectedLanguage = _o[1];
    var _p = useState(false), openEdit = _p[0], setOpenEdit = _p[1];
    var _q = useState(false), openCreate = _q[0], setOpenCreate = _q[1];
    var _r = useState(false), openDeleteModal = _r[0], setOpenDeleteModal = _r[1];
    var _s = useState(null), deleteId = _s[0], setDeleteId = _s[1];
    var _t = useState(null), recordId = _t[0], setRecordId = _t[1];
    var languageOptions = useMemo(function () {
        var _a;
        return ((_a = languageConf === null || languageConf === void 0 ? void 0 : languageConf.enabled_language_codes) !== null && _a !== void 0 ? _a : []);
    }, [languageConf === null || languageConf === void 0 ? void 0 : languageConf.enabled_language_codes]);
    var handleLanguageChange = function (event) {
        var _a, _b;
        var value = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        if (!isString(value) || !value)
            return;
        setSelectedLanguage(value);
    };
    var translationData = Object.entries(((_e = (_d = record === null || record === void 0 ? void 0 : record.settings) === null || _d === void 0 ? void 0 : _d.i18n) === null || _e === void 0 ? void 0 : _e[selectedLanguage]) || {}).map(function (_a) {
        var key = _a[0], value = _a[1];
        return ({
            id: key,
            value: value,
        });
    });
    var editAction = function (id) {
        setOpenEdit(true);
        setRecordId(id);
    };
    var deleteAction = function (id) {
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var handleCloseEditDrawer = function () {
        setRecordId(null);
        setOpenEdit(false);
    };
    var handleCreateText = function (e) {
        var _a, _b;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        if (!e || !(e === null || e === void 0 ? void 0 : e.presentation) || !((_c = e === null || e === void 0 ? void 0 : e.presentation) === null || _c === void 0 ? void 0 : _c.i18n))
            return;
        var newKey = (_g = (_f = (_e = (_d = e === null || e === void 0 ? void 0 : e.presentation) === null || _d === void 0 ? void 0 : _d.i18n) === null || _e === void 0 ? void 0 : _e[selectedLanguage]) === null || _f === void 0 ? void 0 : _f.newKey) !== null && _g !== void 0 ? _g : "";
        var newValue = (_l = (_k = (_j = (_h = e === null || e === void 0 ? void 0 : e.presentation) === null || _h === void 0 ? void 0 : _h.i18n) === null || _j === void 0 ? void 0 : _j[selectedLanguage]) === null || _k === void 0 ? void 0 : _k.newVal) !== null && _l !== void 0 ? _l : "";
        if (!newValue || !newValue)
            return;
        update("sequent_backend_tenant", {
            id: record === null || record === void 0 ? void 0 : record.id,
            data: __assign(__assign({}, record), { settings: __assign(__assign({}, ((_m = record === null || record === void 0 ? void 0 : record.settings) !== null && _m !== void 0 ? _m : {})), { i18n: __assign(__assign({}, ((_p = (_o = record === null || record === void 0 ? void 0 : record.settings) === null || _o === void 0 ? void 0 : _o.i18n) !== null && _p !== void 0 ? _p : {})), (_a = {}, _a[selectedLanguage] = __assign(__assign({}, ((_s = (_r = (_q = record === null || record === void 0 ? void 0 : record.settings) === null || _q === void 0 ? void 0 : _q.i18n) === null || _r === void 0 ? void 0 : _r[selectedLanguage]) !== null && _s !== void 0 ? _s : {})), (_b = {}, _b[newKey] = newValue, _b)), _a)) }) }),
            previousData: record,
        }, {
            onError: function () {
                notify(t("electionEventScreen.localization.notify.error"), { type: "error" });
                setOpenCreate(false);
            },
            onSuccess: function () {
                notify(t("electionEventScreen.localization.notify.success"), { type: "success" });
                setOpenCreate(false);
            },
        });
    };
    var handleEditText = function (e) {
        var _a, _b;
        var _c, _d, _e, _f;
        console.log({ e: e });
        if (!e || !recordId)
            return;
        var editVal = (_c = e === null || e === void 0 ? void 0 : e.editableVal) !== null && _c !== void 0 ? _c : "";
        if (!editVal)
            return;
        update("sequent_backend_tenant", {
            id: record === null || record === void 0 ? void 0 : record.id,
            data: __assign(__assign({}, record), { settings: __assign(__assign({}, record === null || record === void 0 ? void 0 : record.settings), { i18n: __assign(__assign({}, (_d = record === null || record === void 0 ? void 0 : record.settings) === null || _d === void 0 ? void 0 : _d.i18n), (_a = {}, _a[selectedLanguage] = __assign(__assign({}, (_f = (_e = record === null || record === void 0 ? void 0 : record.settings) === null || _e === void 0 ? void 0 : _e.i18n) === null || _f === void 0 ? void 0 : _f[selectedLanguage]), (_b = {}, _b[recordId] = editVal, _b)), _a)) }) }),
            previousData: record,
        }, {
            onError: function () {
                notify(t("electionEventScreen.localization.notify.error"), { type: "error" });
                handleCloseEditDrawer();
            },
            onSuccess: function () {
                notify(t("electionEventScreen.localization.notify.success"), { type: "success" });
                handleCloseEditDrawer();
            },
        });
    };
    var confirmDeleteAction = function () {
        var _a;
        var _b, _c, _d;
        if (!deleteId || !selectedLanguage)
            return;
        var updatedI18nForLanguage = __assign({}, (_c = (_b = record === null || record === void 0 ? void 0 : record.settings) === null || _b === void 0 ? void 0 : _b.i18n) === null || _c === void 0 ? void 0 : _c[selectedLanguage]);
        delete updatedI18nForLanguage[deleteId];
        update("sequent_backend_tenant", {
            id: record === null || record === void 0 ? void 0 : record.id,
            data: __assign(__assign({}, record), { settings: __assign(__assign({}, record === null || record === void 0 ? void 0 : record.settings), { i18n: __assign(__assign({}, (_d = record === null || record === void 0 ? void 0 : record.settings) === null || _d === void 0 ? void 0 : _d.i18n), (_a = {}, _a[selectedLanguage] = updatedI18nForLanguage, _a)) }) }),
            previousData: record,
        }, {
            onError: function () {
                notify(t("electionEventScreen.localization.notify.error"), { type: "error" });
                handleCloseEditDrawer();
            },
            onSuccess: function () {
                notify(t("electionEventScreen.localization.notify.success"), { type: "success" });
                handleCloseEditDrawer();
            },
        });
    };
    var actions = [
        { icon: _jsx(EditIcon, {}), action: editAction },
        { icon: _jsx(DeleteIcon, {}), action: deleteAction },
    ];
    if (!languageOptions || !selectedLanguage) {
        return (_jsx(_Fragment, { children: _jsx(Typography, __assign({ variant: "h4", paragraph: true }, { children: t("electionEventScreen.localization.emptyHeader") })) }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs(SimpleForm, __assign({ toolbar: false }, { children: [_jsxs(Box, __assign({ sx: {
                            flexGrow: 1,
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            justifyContent: "space-between",
                        } }, { children: [_jsxs(FormControl, __assign({ sx: { width: "50%" } }, { children: [_jsx(InputLabel, __assign({ id: "select-language" }, { children: t("electionEventScreen.localization.selectLanguage") })), _jsx(Select, __assign({ labelId: "select-language", fullWidth: true, label: t("electionEventScreen.localization.selectLanguage"), onChange: handleLanguageChange, value: selectedLanguage }, { children: languageOptions &&
                                            languageOptions.map(function (lang) {
                                                return (_jsx(MenuItem, __assign({ value: lang }, { children: t("common.language.".concat(lang)) }), lang));
                                            }) }))] }), "select-language"), _jsxs("div", __assign({ className: "list-actions" }, { children: [_jsx(Button, __assign({ onClick: function () { return setOpenCreate(true); }, label: t("common.label.add") }, { children: _jsx(Add, {}) })), _jsx(Drawer, __assign({ anchor: "right", open: openCreate, onClose: function () {
                                            setOpenCreate(false);
                                        }, PaperProps: {
                                            sx: { width: "30%" },
                                        } }, { children: _jsx(SimpleForm, __assign({ onSubmit: handleCreateText, toolbar: _jsx(SaveButton, { sx: { marginInline: "1rem" } }) }, { children: _jsxs(_Fragment, { children: [_jsx(PageHeaderStyles.Title, { children: t("electionEventScreen.localization.common.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("electionEventScreen.localization.common.subTitle") }), _jsx(TextInput, { source: "presentation.i18n.".concat(selectedLanguage, ".newKey"), label: t("electionEventScreen.localization.labels.key") }), _jsx(TextInput, { source: "presentation.i18n.".concat(selectedLanguage, ".newVal"), label: t("electionEventScreen.localization.labels.value"), multiline: true })] }) })) }))] }))] })), _jsx(List, __assign({ actions: false, sx: { flexGrow: 1, width: "100%" } }, { children: _jsxs(Datagrid, __assign({ data: translationData, total: translationData.length, bulkActionButtons: false }, { children: [_jsx(TextField, { source: "id", label: t("electionEventScreen.localization.labels.key") }), _jsx(TextField, { source: "value", label: t("electionEventScreen.localization.labels.value") }), _jsx(WrapperField, __assign({ label: "Actions" }, { children: _jsx(ActionsColumn, { actions: actions }) }))] })) }))] })), _jsx(Drawer, __assign({ anchor: "right", open: openEdit, onClose: handleCloseEditDrawer, PaperProps: {
                    sx: { width: "40%" },
                } }, { children: _jsx(SimpleForm, __assign({ record: ((_g = (_f = record === null || record === void 0 ? void 0 : record.settings) === null || _f === void 0 ? void 0 : _f.i18n) === null || _g === void 0 ? void 0 : _g[selectedLanguage]) || {}, toolbar: _jsx(SaveButton, { sx: { marginInline: "1rem" } }), onSubmit: handleEditText }, { children: _jsxs(_Fragment, { children: [_jsx(PageHeaderStyles.Title, { children: t("electionEventScreen.localization.common.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("electionEventScreen.localization.common.subTitle") }), _jsx(TextInput, { source: "editableKey", label: t("electionEventScreen.localization.labels.key"), defaultValue: recordId !== null && recordId !== void 0 ? recordId : undefined, disabled: true }), _jsx(TextInput, { source: "editableVal", label: t("electionEventScreen.localization.labels.value"), defaultValue: recordId
                                    ? (_j = (_h = record === null || record === void 0 ? void 0 : record.settings) === null || _h === void 0 ? void 0 : _h.i18n) === null || _j === void 0 ? void 0 : _j[selectedLanguage][recordId]
                                    : undefined, multiline: true })] }) })) })), _jsx(Dialog, __assign({ variant: "warning", open: openDeleteModal, ok: t("common.label.delete"), cancel: t("common.label.cancel"), title: t("common.label.warning"), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                        // console.log('handle close')
                    }
                    setOpenDeleteModal(false);
                    setDeleteId(null);
                } }, { children: t("common.message.delete") }))] }));
};
export default SettingsLocalization;
